import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import $ from "jquery";
import isEqual from "lodash/isEqual";
import Collapsible from "react-collapsible";

import { setActiveStep } from "../../store/modules/cart";
import { hasClass } from "../../lib/utils";

import "./StepBox.scss";
import Overview from "./Overview";

export const StepContext = React.createContext({
  isStepOpen: undefined
});

/**
 * StepBox
 */
class StepBox extends Component {
  static propTypes = {
    number: PropTypes.number,
    totalSteps: PropTypes.number,
    title: PropTypes.string,
    nextStepBtnText: PropTypes.string,
    isActive: PropTypes.bool,
    showButton: PropTypes.bool,
    isOpen: PropTypes.bool,
    onNextStep: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    t: PropTypes.func,
    setActiveStep: PropTypes.func.isRequired,
    isValid: PropTypes.bool,
    hasOverview: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string
  };

  static defaultProps = {
    number: 0,
    totalSteps: 4,
    title: "",
    hasOverview: false,
    isActive: false,
    isOpen: false,
    isValid: false,
    showButton: true,
    onNextStep: null,
    t: null,
    children: null,
    nextStepBtnText: null,
    className: null
  };

  static contextTypes = {
    showStepNumbers: PropTypes.bool
  };

  static childContextTypes = {
    isStepOpen: PropTypes.bool
  };

  getChildContext() {
    return {
      isStepOpen: this.props.isOpen
    };
  }

  constructor(props) {
    super(props);
    this.stepBoxRef = React.createRef();
    this.innerRef = React.createRef();
  }

  shouldComponentUpdate2(nextProps) {
    // for some reason this does not work in the connect() "areMergedPropsEqual" option
    return !isEqual(this.props, nextProps);
  }

  componentDidUpdate(prevProps) {
    if (!hasClass("ie-lte-9")) {
      return;
    }

    // ref === Collapsible__contentOuterInner
    const $el = $(this.stepBoxRef.current.innerRef).parents(".Collapsible");

    // open -> closed
    if (prevProps.isOpen === true && this.props.isOpen === false) {
      $el
        .find(".Collapsible__trigger")
        .removeClass("is-open")
        .addClass("is-closed");
      $el.find(".Collapsible__contentOuter").css("height", "auto");
    }
    // closed -> open
    if (prevProps.isOpen === false && this.props.isOpen === true) {
      $el
        .find(".Collapsible__trigger")
        .addClass("is-open")
        .removeClass("is-closed");
      $el.find(".Collapsible__contentOuter").css("height", "auto");
    }
  }

  onAnimateStep = () => {
    const $container = $(".Cart__Container");
    if ($container.length > 0 && $container.offset().top) {
      $("html, body").animate({ scrollTop: $container.offset().top - $("#header").height() - 20 }, 500, "linear");
    }
  };

  onNextStep = () => {
    if (this.props.onNextStep) {
      this.props.onNextStep();
    }
  };

  onOpenStep = () => {
    this.props.setActiveStep(this.props.number);
    this.onAnimateStep();
  };

  renderHeader() {
    const clickable = this.props.isActive && !this.props.isOpen;
    const props = { className: "Cart__StepBox__Header" };
    if (clickable) {
      props.className += ` ${props.className}--clickable`;
      props.onClick = this.onOpenStep;
      props.onKeyDown = this.onKeyDown;
      props.role = "button";
      props.tabIndex = -1;
    }
    return (
      <div {...props}>
        <div className="Cart__StepBox__Header__Title">
          <div className="Cart__StepBox__Header__Title__Step">
            {this.context.showStepNumbers ? `${this.props.t("Step")} ${this.props.number}` : null}{" "}
          </div>
          {this.props.title}
        </div>
        <div className="Cart__StepBox__Header__Icons">
          {this.props.isValid && (
            <div className="Cart__StepBox__Header__Check">
              <i className="fa fa-check" />
            </div>
          )}
          {clickable && (
            <div className="Cart__StepBox__Header__Edit">
              <i className="fa fa-edit" />
            </div>
          )}
        </div>
      </div>
    );
  }

  render() {
    const classes = ["Cart__StepBox", this.props.className].filter(v => !!v);
    if (this.props.isActive) {
      classes.push("Cart__StepBox--active");
    }
    if (this.props.isValid) {
      classes.push("Cart__StepBox--valid");
    }

    // const maxHeight = this.innerRef.current ? this.innerRef.current.scrollHeight : 0;
    const style = {
      // maxHeight: this.props.isOpen ? (maxHeight + 768) : 0,
      // overflow: 'hidden',
      // transition: this.props.isOpen ? 'max-height 500ms ease-in' : 'max-height 500ms ease-out',
    };

    const Header = this.renderHeader();

    return (
      <Collapsible
        key={`Collapsible${this.props.number}`}
        triggerDisabled
        open={this.props.isOpen}
        trigger={Header}
        accordionPosition={this.props.number - 1}
        className={classes.join(" ")}
        ref={this.stepBoxRef}
      >
        <div
          ref={this.innerRef}
          style={style}
          className={`Cart__StepBox__Container${
            this.props.isOpen ? " Cart__StepBox__Container--isOpen" : " Cart__StepBox__Container--isClosed"
          }`}
        >
          <StepContext.Provider
            value={{
              isStepOpen: this.props.isOpen
            }}
          >
            {this.props.children}
          </StepContext.Provider>
        </div>

        <div className="Cart__StepBox__NextButton mb-3">
          {this.props.isOpen && this.props.onNextStep !== false && this.props.showButton && (
            <button type="button" className="btn btn-secondary" onClick={this.onNextStep}>
              {this.props.nextStepBtnText ||
                this.props.t(this.props.number + 1 === this.props.totalSteps ? "Just 1 more step" : "Next step", {
                  step: this.props.number + 1,
                  total: this.props.totalSteps
                })}
            </button>
          )}
        </div>

        {this.props.isOpen && this.props.hasOverview && <Overview key="cart_overview" />}
      </Collapsible>
    );
  }
}

export default translate()(
  connect(
    () => ({}),
    {
      setActiveStep
    }
  )(StepBox)
);
